import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { PortalFooterDataPropType } from '../../../CustomPropTypes/PortalPropTypes';
import { PageFooter } from '../../components/PageFooter';

import './PortalFooter.scss';
import { selectIsInAppWebview } from '../../../ReduxStorage/location/selectors';

class InnerPortalFooter extends React.PureComponent {
  static displayName = 'PortalFooter';

  static propTypes = {
    footerData: PortalFooterDataPropType.isRequired,
    inAppWebview: PropTypes.bool.isRequired,
  };

  render() {
    // XXX: The mobile app will have a custom user agent. We can use this
    // to hide the footer (as required by iOS app store rules). See BUFF-2444
    const { inAppWebview, footerData } = this.props;
    if (inAppWebview) {
      return null;
    }

    return (
      <portal-footer>
        <PageFooter {...{ footerData }} />
      </portal-footer>
    );
  }
}

export const PortalFooter = connect((state) => ({
  inAppWebview: selectIsInAppWebview(state),
}))(InnerPortalFooter);
